<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src='../../../../favicon.png' width='50px'/>
      {{appName}}
      Expofin
    </a>
  </div>
</div>

<!-- <div class="toggle-container">
 <nb-toggle labelPosition="end" [checked]="currentTheme === 'material-dark'" status="primary" (checkedChange)="toggleTheme()" >
   <nb-icon icon="moon-outline"></nb-icon>
 </nb-toggle>
</div> -->

<!-- https://akveo.github.io/nebular/docs/components/actions/overview#nbactionscomponent -->
<div class="header-container">
  <nb-actions size="small">

    <!-- <nb-action
      class="control-item"
      [icon]="currentTheme === 'material-dark' ? 'sun-outline' : 'moon-outline'"
      title="Modalita notturna"
      (click)="toggleTheme()"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
    ></nb-action> -->
    <!-- <nb-action
      class="control-item"
      icon="bell-outline"
      badgeText="2"
      badgeStatus="danger"
      badgePosition="top right"
      badgeDot="true"
      title="Avvisi"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
    ></nb-action> -->
    <!-- TODO Mettere email corretta e con id utente del user loggato -->
    <nb-action
      class="control-item"
      icon="question-mark-circle-outline"
      title="Richiedi assistenza"
      href="mailto:assistenza@bigdeal.com?subject=Richiesta di Assistenza"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
    ></nb-action>
    <nb-action
      class="user-action"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name??''"
               [picture]="user?.picture??''"
               [title]="user?.title ?? ''"
               shape="semi-round"
      >
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
